import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

export const AGB = () => {
  const { t } = useTranslation();
  const sections = t('agb.sections', { returnObjects: true }) || [];

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem 1.5rem' }} data-testid="agb-page">
      <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', color: '#2563eb', textDecoration: 'none', fontWeight: 600, marginBottom: '1.5rem' }}>
        <ArrowLeft size={18} /> {t('common.back')}
      </Link>

      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
        <FileText size={28} style={{ color: '#2563eb' }} />
        <h1 style={{ fontSize: '1.75rem', fontWeight: 800, margin: 0 }}>{t('agb.title')}</h1>
      </div>
      <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginBottom: '2rem' }}>
        {t('agb.lastUpdated')}: March 2026
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
        {Array.isArray(sections) && sections.map((section, i) => (
          <div key={i} style={{ background: '#f8fafc', borderRadius: '12px', padding: '1.25rem 1.5rem', border: '1px solid #e2e8f0' }}>
            <h2 style={{ fontSize: '1.05rem', fontWeight: 700, marginBottom: '0.5rem', color: '#1e293b' }}>
              {section.title}
            </h2>
            <p style={{ color: '#475569', lineHeight: 1.7, margin: 0, fontSize: '0.95rem' }}>
              {section.content}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
